var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('b-card',{staticClass:"box mb-5",attrs:{"title":_vm.title,"img-src":_vm.img,"img-top":""}},[_c('p',{staticClass:"card-text"},[_vm._t("default")],2)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ef10712","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Organisms/QiitaCard.vue
// module id = null
// module chunks = 